module.exports = __webpack_public_path__ + "76458f61f3a24f9e470a850f40340c1d.svg";